import getRandomInt from './getRandomInt.js';

export default function getRandomResult (results) {
  if (!results.length) return null;

  return results[getRandomInt(results.length - 1)];
}
